import React from 'react';
import Awards from './awards';
import * as S from './style';
import ListItem from '../feature-list/list-item';
import Image from '../../../components/loggedout/common/Image';
import { white } from '../../../components/loggedout/shared-styles/Colors';
import { featureList } from './data';
import { CTAOfferButton } from '../../../../../landing-pages/js/common/styled-components/styled-components';
// import Routes from '../../../../routes/routes';
import { Link } from 'react-router-dom';
import StarRating from '~images/sem/star-rating.svg';
// import { PARENT_SIGNUP_PATH } from '../../../routes/route-paths';

const AwardsSection = ({ btnClickEvent, ctaText, urlToRedirect }) => {
  // let ctaText = 'Sign up for free';
  return (
    <S.ContainerWrapper noBackground={true}>
      <S.HeadingText>SplashLearn is used by 1 in 3 US Schools</S.HeadingText>
      <S.ListWrapper>
        {
          featureList.map((item, idx) =>
            <ListItem
              item={item}
              key={idx}
              fColor={white}
            />
          )
        }
      </S.ListWrapper>
      <Awards />
       <S.ButtonWrapper>
        <CTAOfferButton white={true} textColor="#090A4A" fontWeight="600" hoverColor="rgb(237, 237, 249)">
          <a href={urlToRedirect} onClick={btnClickEvent}>
            {ctaText}
          </a>
        </CTAOfferButton>
      </S.ButtonWrapper>
      <S.RatingImageWrapper>
        <Image alt="image" src={StarRating} />
      </S.RatingImageWrapper>
      <S.Rating>We have a 4.6/5 star rating across our products</S.Rating>
    </S.ContainerWrapper>
  )
}

export default AwardsSection;